import { createFileRoute } from "@tanstack/react-router";
import { AsyncProductionLineStatusView } from "src/components/views/erp/production/productionLineStatus/ProductionLineStatusView.tsx";
import { ProductionLineStatusViewApi } from "src/api/generated/erp/production/productionLineStatus/api/productionLineStatusViewApi.ts";
import { useKeptAliveGeneratedView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/production/productionLinesStatus/$productionLineId")({
	staticData: {
		legacyViewKey: "productionLineStatusGeneratedViews",
		listGeneratedViews: async () =>
			(await ProductionLineStatusViewApi.getProductionLinesForStatusViewGeneration()).map((productionLine) => ({
				id: productionLine.productionLineId,
				title: productionLine.productionLineName,
			})),
	},
	component: RouteComponent,
});

function RouteComponent() {
	const {
		view: { generatedId: id },
		isActive,
	} = useKeptAliveGeneratedView();
	return <AsyncProductionLineStatusView productionLineId={id} isActive={isActive} />;
}
